var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"notification is-success",attrs:{"role":"status","aria-live":"polite"}},[_vm._v(" "+_vm._s(_vm.$t('payment.payment-processing'))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }